module.exports = __webpack_public_path__ + "static/media/68-iveco-mercedes.746da8b8.jpg";